import React from "react";
import { Box, Typography } from "@mui/material";

const StageInactive = () => {
  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column", // Stack the text vertically
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center", // Center the text
      }}
    >
      <Typography variant="h4" gutterBottom>
        Stage Inactive
      </Typography>
      <Typography variant="subtitle1" color="text.secondary">
        Finish the previous stage to unlock this stage and move forward.
      </Typography>
    </Box>
  );
};

export default StageInactive;
